var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-bar-item__section"},[_c('div',{staticClass:"search-bar-item__section--label"},[(_vm.label)?_c('p',{staticClass:"label center"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]),_c('div',{staticClass:"search-bar-item__section--slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }